<template>
  <div class="html2pdf__page" slot="pdf-content">
    <template v-if="elements.packets ?? true">
      <div
        v-for="(_, i) in packets"
        :key="i"
        class="flex flex-wrap"
        style="height: 100%"
      >
        <div class="flex flex-col" style="width: 50%">
          <div style="height: 50%; padding: 3rem; display: flex; align-items: center;">
            <layout-print-stock-movement-packet
              :as-content="false"
              :packet="packets[i][0]"
              :stock-movement="stockMovement"
              :total="totalPacket || stockMovement.packets.length"
            />
          </div>
          <div style="height: 50%; padding: 3rem; display: flex; align-items: center;">
            <layout-print-stock-movement-packet
              v-if="packets[i].length > 1"
              :as-content="false"
              :packet="packets[i][1]"
              :stock-movement="stockMovement"
              :total="totalPacket || stockMovement.packets.length"
            />
          </div>
        </div>
        <div class="flex flex-col" style="width: 50%">
          <div style="height: 50%; padding: 3rem; display: flex; align-items: center;">
            <layout-print-stock-movement-packet
              v-if="packets[i].length > 2"
              :as-content="false"
              :packet="packets[i][2]"
              :stock-movement="stockMovement"
              :total="totalPacket || stockMovement.packets.length"
            />
          </div>
          <div style="height: 50%; padding: 3rem; display: flex; align-items: center;">
            <layout-print-stock-movement-packet
              v-if="packets[i].length > 3"
              :as-content="false"
              :packet="packets[i][3]"
              :stock-movement="stockMovement"
              :total="totalPacket || stockMovement.packets.length"
            />
          </div>
        </div>
        <div class="pagebreak"></div>
      </div>
    </template>
  </div>
</template>
<script>
import LayoutPrintStockMovementPacket from './LayoutPrintStockMovementPacket.vue';

export default {
  name: 'PrintKemasan',
  components: {
    LayoutPrintStockMovementPacket,
  },
  props: {
    totalPacket: Number,
    elements: {
      type: Object,
      default: () => ({
        packets: true,
        receipt: true,
      }),
    },
    singlePacket: Object,
    stockMovement: {
      type: Object,
      default: () => ({
        code: null,
        date: null,
        order: {
          code: null,
          address: null,
          phone: null,
          name: null,
          destinationOffice: null,
        },
        packets: [],
      }),
    },
  },
  computed: {
    packets() {
      if (this.singlePacket) {
        return [
          [this.singlePacket]
        ]
      }

      return this.stockMovement.packets.reduce((groups, packet) => {
        const lastGroup = groups[groups.length - 1];

        if (!lastGroup || lastGroup.length === 4) {
          groups.push([packet]);
        } else {
          lastGroup.push(packet);
        }

        return groups;
      }, []);
    },
  },
  methods: {},
};
</script>
